import React, { Component } from "react";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import { toast } from "react-toastify";
import T2 from "../Helpers/T2";
import Spinner from "../Components/Spinner";

export default class BillView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: {},
        };
    }

    componentWillMount() {
        const path = window.location.pathname;
        const token = path.split("/").pop();

        Express.callPublic("bill-view", { billToken: token }, (results) => {
            if (results.billData) {
                window.location.href = results.billData;
            } else {
                toast.error(<T2 id="32">There was an error loading bill.</T2>);
            }
        });
    }

    render() {
        try {
            if (this.state.overrideHTML) {
                return this.state.overrideHTML;
            }

            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                >
                    <Spinner width="40px" />
                    <div>Loading bill...</div>
                </div>
            );
        } catch (e) {
            console.log(e);
            return <div />;
        }
    }
}
